import * as ko from "knockout";
import {ICustomSystemAccess, IComboboxOptions_SystemRole} from "../../combobox/system-role"
import {ErrorTracker} from "../../../error.tracker";
import {RuleMutable} from "./RuleMutable";
import {getSourceTranslation} from "../../../util/misc";
import {global, lm} from "../../../appContext";
import {nsRule} from "../mutable/rule/nsRule";
import {HIERARCHY_ARROW, ObjectTypeId} from "../../../constants";
import {Settings} from "./Settings";
import {ICondition, IRuleset, ISearchParams, ISyncField} from "../../../index";
import {nsSyncFields} from "../../../req/nsSyncFields";
import {IComboboxV2Options} from "../../combobox/v2";
import {createApiListPromise, createBaseTextMatch, createServiceListPromise} from "../../combobox/v2-sources";
import {NO_DATA_MESSAGE} from "../../../constants/Language";
import {_} from 'lodash';
import ruleHtml from './rule.html?raw';

export let template = ruleHtml;

interface IParams {
    settings: Settings
    ruleMutable: RuleMutable;
}

export class viewModel {
    private readonly ObjectTypeId = ObjectTypeId;
    private readonly et: ErrorTracker = global.errorAreas.get("rules.wizard");
    private readonly ruleMutable: RuleMutable;
    private settings: Settings;
    private getSyncfieldsParams: any
    private readonly selected: KnockoutObservable<IRuleset | null> = ko.observable(null)

    constructor(params: IParams) {
        this.settings = params.settings;
        this.ruleMutable = params.ruleMutable;
        this.getSyncfieldsParams = nsSyncFields.getSyncfieldsRequestParams(this.settings.objectType()?.id ?? ObjectTypeId.User)
    }

    private getSourceTranslation = getSourceTranslation

    private getSyncFieldText = nsRule.getSyncFieldText;
    private getSyncFieldTitle = nsRule.getSyncFieldTitle;
    private getSyncFieldStyle = nsRule.getSyncFieldStyle;

    private getName(obj: ICustomSystemAccess): string {
        let ret = `${obj.system.name}`
        if (obj.role) {
            ret += ` ${HIERARCHY_ARROW} ${obj.role.name}`
        }
        return ret
    }

    private getComboboxSystemRoleParams(): IComboboxOptions_SystemRole {
        const input = ko.observable('')
        return {
            comboboxOptions: {
                inputAttrs: {placeholder: lm.t('choose|td')},
                input: input,
                selectionMode: 'pick',
                option: {
                    dataType: (o: ICustomSystemAccess) => o.role ? 'role' : 'system',
                    disabled: (o: ICustomSystemAccess) => this.ruleMutable.permission().includes(o),
                },
                onSelect: (o: ICustomSystemAccess | null) => {
                    if (!o) {
                        return
                    }
                    this.ruleMutable.permission.push(o)
                },
            },
            showIcon: true,
        }
    }

    private getComboboxAttributeField(): IComboboxV2Options<ISyncField> {
        const labelFn = (o: ISyncField) => this.getSourceTranslation(o)
        const apiList = createApiListPromise<ISyncField>({
            api: 'getsyncfields',
            isSearch: false,
            params: this.getSyncfieldsParams,
        })
        return {
            promise: apiList.promise,
            onDispose: apiList.onDispose,
            emptyPreparedListMessage: NO_DATA_MESSAGE,
            inputAttrs: {placeholder: lm.t('choose|td') ?? ''},
            initialMatch: o => o.name == this.ruleMutable.attribute(),
            option: {
                label: labelFn,
                match: createBaseTextMatch(labelFn),
                tooltip: o => {
                    const title = o.description
                    return title == null ? labelFn(o) : String(title)
                },
            },
            prepareData: {
                sort: (items) => _.sortBy(items, (o: ISyncField) => this.getSourceTranslation(o).toLowerCase()),
            },
            onSelect: (o) => {
                if (o != null) {
                    this.ruleMutable.attribute(o.name)
                }
            },
        }
    }

    private getComboboxAttributeConditionValue(): IComboboxV2Options<ICondition> {
        const listSource = createServiceListPromise<ICondition>({
            name: 'getconditions',
            params: {} as ISearchParams,
        })
        return {
            inputAttrs: {placeholder: lm.t('choose|td')},
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            onSelect: o => this.ruleMutable.argumentoperator(o?.name ?? null),
            initialMatch: o => o.name == this.ruleMutable.argumentoperator(),
            option: {
                label: o => lm.t('condition.' + o.name) ?? '',
            },
            prepareData: {
                filter: o => this.ruleMutable.conditionFilter(o),
            },
        }
    }
}
